(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sale-price-pill"] && !Shopify.designMode) return;
  try {
    (function () {
    var PRICE_KEYS = ['filter.v.price.gte', 'filter.v.price.lte'];

    // Filter values are in the shopper's currency. Shopify gives the rate from
    // the store currency on window.Shopify.currency.
    function rate() {
      var c = window.Shopify && window.Shopify.currency;
      var r = c && parseFloat(c.rate);
      return r > 0 ? r : 1;
    }

    function convert(amount) {
      var value = parseFloat(amount) * rate();
      return Math.round(value * 100) / 100;
    }

    function same(a, b) {
      if (a === null || b === null) return a === b;
      return Math.abs(parseFloat(a) - parseFloat(b)) < 0.01;
    }

    function update() {
      var here = new URL(window.location.href);
      var currentMin = here.searchParams.get(PRICE_KEYS[0]);
      var currentMax = here.searchParams.get(PRICE_KEYS[1]);

      document.querySelectorAll('[data-sale-pill]').forEach(function (link) {
        var min = link.dataset.min ? convert(link.dataset.min) : null;
        var max = link.dataset.max ? convert(link.dataset.max) : null;
        var on = same(min, currentMin) && same(max, currentMax);

        // Keep the shopper's other filters and sort; drop the page number so
        // the filtered list starts at page 1.
        var url = new URL(here.pathname, window.location.origin);
        here.searchParams.forEach(function (value, key) {
          if (PRICE_KEYS.indexOf(key) === -1 && key !== 'page') url.searchParams.append(key, value);
        });
        if (!on) {
          if (min !== null) url.searchParams.set(PRICE_KEYS[0], min);
          if (max !== null) url.searchParams.set(PRICE_KEYS[1], max);
          // Highest price first, unless the shopper chose an order, so each
          // pill leads with its own range rather than the same cheap items
          // (Jossa, 10/23).
          if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', 'price-descending');
        }
        link.href = url.pathname + url.search;
        if (on) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }
    document.addEventListener('shopify:section:load', update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["class-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
      Judge.me's badge scrolls to its own review widget, but Class Reviews keeps
      that widget hidden (it's only a data source there), so the click went
      nowhere. Send it to the reviews section instead. Listening on document in
      the capture phase runs before Judge.me's handler and survives the theme
      editor re-rendering the block.
    */

    /* The header (and the free-shipping bar above it) stays fixed once you
       scroll, so land the section just below them, not under them. */
    function headerOffset() {
      var offset = 0;
      var bar = document.querySelector('.free-shipping-bar');
      if (bar && getComputedStyle(bar).position === 'fixed') offset += bar.offsetHeight;
      var header = document.getElementById('SiteHeader');
      if (header) offset += header.offsetHeight;
      return offset;
    }

    function toReviews(e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target.closest || !e.target.closest('.class-hero__rating .jdgm-prev-badge')) return;
      var target = document.querySelector('.class-reviews');
      if (!target) return;
      e.preventDefault();
      e.stopPropagation();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Sections above can change height while the page scrolls past them (on
         Timeless Floral Layouts the reviews moved up 79px mid-scroll), so check
         where the section ended up and nudge it once. The timer covers browsers
         without scrollend and the case where no scroll was needed. */
      var landed = false;
      function land() {
        if (landed) return;
        landed = true;
        window.removeEventListener('scrollend', land);
        var gap = target.getBoundingClientRect().top - headerOffset();
        if (Math.abs(gap) > 2) window.scrollTo({ top: window.scrollY + gap, behavior: 'auto' });
      }
      window.addEventListener('scrollend', land);
      setTimeout(land, 1500);

      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - headerOffset(),
        behavior: reduce ? 'auto' : 'smooth'
      });
    }
    document.addEventListener('click', toReviews, true);
    document.addEventListener('keydown', toReviews, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sale-crafty-pick"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function todayInNewYork() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
      return parts.year + '-' + parts.month + '-' + parts.day;
    }

    // Today's pick; else the latest one before today; else the first.
    function chooseDay(days) {
      var today = todayInNewYork();
      var best = null;
      days.forEach(function (day) {
        var date = day.dataset.date;
        if (!date || date > today) return;
        if (!best || date >= best.dataset.date) best = day;
      });
      return best || days[0] || null;
    }

    function setUp(card) {
      if (card.dataset.craftyReady) return;
      card.dataset.craftyReady = 'true';
      var days = Array.prototype.slice.call(card.querySelectorAll('[data-crafty-day]'));
      var day = chooseDay(days);
      days.forEach(function (d) { d.hidden = d !== day; });
      if (!day) return;

      var track = day.querySelector('[data-crafty-track]');
      var slides = day.querySelectorAll('[data-crafty-slide]');
      var bars = Array.prototype.slice.call(day.querySelectorAll('[data-crafty-bar]'));
      var link = day.querySelector('[data-crafty-link]');
      var count = slides.length;
      var index = 0;
      card.style.setProperty('--crafty-seconds', (parseFloat(card.dataset.seconds) || 5) + 's');

      // Photos start lazy so hidden days never download. Load the shown day's
      // now: its later slides sit off to the side inside the card, where lazy
      // loading wouldn't fetch them before they slide in.
      day.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });

      function show(next) {
        index = (next + count) % count;
        track.style.transform = 'translateX(' + (-100 * index) + '%)';
        Array.prototype.forEach.call(slides, function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        bars.forEach(function (bar, i) {
          bar.classList.toggle('is-done', i < index);
          if (i === index) {
            bar.setAttribute('aria-current', 'true');
            // Restart the fill animation on the new bar.
            var fill = bar.firstElementChild;
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
          } else {
            bar.removeAttribute('aria-current');
          }
        });
      }

      if (count < 2) return;

      bars.forEach(function (bar, i) {
        bar.addEventListener('click', function (event) {
          event.preventDefault();
          show(i);
        });
        bar.addEventListener('animationend', function () {
          if (i === index) show(index + 1);
        });
      });

      // Autoplay only while the card is on screen, the tab is visible, and the
      // shopper isn't hovering or focused on it.
      var onScreen = false;
      var held = false;
      function sync() {
        var play = !reduceMotion.matches;
        card.toggleAttribute('data-playing', play);
        card.toggleAttribute('data-paused', play && (!onScreen || held || document.hidden));
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.4 }).observe(card);
      } else {
        onScreen = true;
      }
      card.addEventListener('mouseenter', function () { held = true; sync(); });
      card.addEventListener('mouseleave', function () { held = false; sync(); });
      card.addEventListener('focusin', function () { held = true; sync(); });
      card.addEventListener('focusout', function () { held = false; sync(); });
      document.addEventListener('visibilitychange', sync);
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', sync);

      // Swipe sideways to change photo. Vertical moves are left to the page
      // (touch-action: pan-y), and a swipe never opens the product.
      var startX = null;
      var startY = 0;
      var swiped = false;
      day.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
        startY = event.clientY;
        swiped = false;
      });
      day.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          show(index + (dx < 0 ? 1 : -1));
        }
      });
      day.addEventListener('pointercancel', function () { startX = null; });
      link.addEventListener('click', function (event) {
        if (swiped) {
          event.preventDefault();
          swiped = false;
        }
      });

      show(0);
      sync();
    }

    function init() {
      document.querySelectorAll('[data-crafty-pick]').forEach(setUp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sale-hero"] && !Shopify.designMode) return;
  try {
    (function () {
    // The end time is typed in New York time ("2026-10-30 23:59"). Work out
    // New York's offset from UTC for that date, so a shopper anywhere sees the
    // same moment, and daylight saving is handled by the browser.
    function parseNewYork(text) {
      var m = String(text).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return NaN;
      var asUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[4] ? 0 : 59);
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', hourCycle: 'h23',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
      }).formatToParts(new Date(asUtc)).reduce(function (o, p) { o[p.type] = +p.value; return o; }, {});
      var nyAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      return asUtc + (asUtc - nyAsUtc);
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    // "weekly": the coming Sunday 23:59 in New York (today, when it is
    // Sunday). The weekly sale runs Monday to Sunday.
    function nextSundayNewYork() {
      var today = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short'
      }).formatToParts(new Date()).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
      var days = { Sun: 0, Mon: 6, Tue: 5, Wed: 4, Thu: 3, Fri: 2, Sat: 1 }[today.weekday] || 0;
      var sunday = new Date(Date.UTC(+today.year, +today.month - 1, +today.day + days));
      return parseNewYork(sunday.getUTCFullYear() + '-' + (sunday.getUTCMonth() + 1) + '-' + sunday.getUTCDate() + ' 23:59');
    }

    function start(el) {
      if (el.dataset.saleCountdownReady) return;
      el.dataset.saleCountdownReady = 'true';
      var end = el.dataset.endsAt === 'weekly' ? nextSundayNewYork() : parseNewYork(el.dataset.endsAt);
      if (isNaN(end)) {
        el.hidden = true;
        return;
      }
      var digits = [1, 2, 3].map(function (n) { return el.querySelector('[data-unit="' + n + '"]'); });
      var labels = [1, 2, 3].map(function (n) { return el.querySelector('[data-unit-label="' + n + '"]'); });
      var timer;
      function show(values, names) {
        for (var i = 0; i < 3; i++) {
          digits[i].textContent = values[i];
          if (labels[i].textContent !== names[i]) labels[i].textContent = names[i];
        }
      }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        var d = Math.floor(left / 86400);
        if (d >= 1) {
          show([String(d), pad(Math.floor(left / 3600) % 24), pad(Math.floor(left / 60) % 60)], [d === 1 ? 'Day' : 'Days', 'Hrs', 'Min']);
        } else {
          show([pad(Math.floor(left / 3600)), pad(Math.floor(left / 60) % 60), pad(left % 60)], ['Hrs', 'Min', 'Sec']);
        }
        el.removeAttribute('data-pending');
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function init() {
      document.querySelectorAll('[data-sale-countdown]').forEach(start);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sale-price-pills"] && !Shopify.designMode) return;
  try {
    (function () {
    // On phones, bring the chosen pill into view so the shopper sees which
    // price range is on without swiping (Jossa, 10/23: the row went back to
    // the far left after the page loaded). Measured on screen, and again once
    // fonts and images are in, as they change the pill widths.
    function reveal(row, item) {
      var box = row.getBoundingClientRect();
      var rect = item.getBoundingClientRect();
      if (rect.left >= box.left - 1 && rect.right <= box.right + 1) return;
      row.scrollLeft += rect.left - box.left;
    }

    function init() {
      document.querySelectorAll('[data-sale-pills] [aria-current="true"]').forEach(function (link) {
        var item = link.closest('.sale-pill');
        var row = link.closest('.sale-pills__row');
        if (!item || !row) return;
        reveal(row, item.parentElement === row ? item : item.parentElement);
      });
    }

    function start() {
      // The pills' own script marks the chosen pill on DOMContentLoaded too,
      // so wait a frame for it.
      requestAnimationFrame(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    window.addEventListener('load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sale-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    // Computers only: when the tabs overflow, the chevrons move one set of 3 at
    // a time. On phones the row is swiped instead (CSS snap), and the current
    // tab is scrolled into view so the shopper sees where they are.
    var desktop = window.matchMedia('(min-width: 769px)');

    function setUp(nav) {
      if (nav.dataset.saleTabsReady) return;
      nav.dataset.saleTabsReady = 'true';
      var row = nav.querySelector('[data-sale-tabs-row]');
      var prev = nav.querySelector('[data-sale-tabs-prev]');
      var next = nav.querySelector('[data-sale-tabs-next]');

      function update() {
        if (!desktop.matches) {
          prev.hidden = next.hidden = true;
          nav.removeAttribute('data-more-before');
          nav.removeAttribute('data-more-after');
          return;
        }
        var max = row.scrollWidth - row.clientWidth;
        var before = row.scrollLeft > 1;
        var after = row.scrollLeft < max - 1;
        prev.hidden = !before;
        next.hidden = !after;
        nav.toggleAttribute('data-more-before', before);
        nav.toggleAttribute('data-more-after', after);
      }

      // Move by 3 tabs. The browser clamps at the end, so the last set stops
      // with the last tab on the right edge and no empty space after it.
      function move(dir) {
        var tabs = row.children; // the block wrappers, one per tab
        if (tabs.length < 2) return;
        var step = tabs[1].offsetLeft - tabs[0].offsetLeft;
        row.scrollTo({ left: row.scrollLeft + dir * step * 3, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // A tab reached with the keyboard comes fully into view.
      row.addEventListener('focusin', function (event) {
        var tab = event.target.closest('.sale-tab');
        if (tab) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });

      // Open on the current tab when it is cut off, on phones too (Jossa,
      // 10/23: the row went back to the far left and hid the current tab).
      // Again once fonts and images are in, as they change the tab widths.
      var current = row.querySelector('[aria-current="page"]');
      var item = current && current.closest('.sale-tab');
      if (item) {
        reveal(row, item);
        window.addEventListener('load', function () { reveal(row, item); update(); });
      }
      update();
    }

    // Scroll a row so the item sits at its start, only when the item is not
    // already fully in view. Measured on screen, so it works whatever the row
    // is positioned inside.
    function reveal(row, item) {
      var box = row.getBoundingClientRect();
      var rect = item.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
      if (rect.left >= box.left + pad - 1 && rect.right <= box.right + 1) return;
      row.style.scrollBehavior = 'auto';
      row.scrollLeft += rect.left - box.left - pad;
      row.style.scrollBehavior = '';
    }

    // A page opened with ?view= (a template preview, or an A/B test that
    // swaps templates that way) keeps it on the tab links, so every tab's page
    // shows the same version.
    function keepView(link) {
      var view = new URLSearchParams(window.location.search).get('view');
      var href = link.getAttribute('href');
      if (!view || !href || href.charAt(0) === '#') return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin || url.searchParams.has('view')) return;
      url.searchParams.set('view', view);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }

    function init() {
      document.querySelectorAll('[data-sale-tabs]').forEach(setUp);
      // Tabs and breadcrumb links mark themselves (a setting on each), so a
      // link to a page on another layout doesn't carry this test's ?view=.
      document.querySelectorAll('[data-sale-keep-view]').forEach(keepView);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    // The cookie banner blocks YouTube until the visitor accepts marketing
    // cookies. It does that by swapping any youtube.com iframe for a notice of
    // its own — which reads "Accept marketing cookies to view this content" but
    // carries no way to accept, and replaces the poster on the way through, so
    // the visitor is left staring at a dead box with nothing to click.
    //
    // So ask first. If marketing is blocked, keep the poster where it is and
    // offer the one thing the app's own notice is missing: a button that opens
    // the cookie preferences. Consent itself is still the visitor's to give —
    // nothing here grants it for them, or routes around the block.
    //
    // Ask Consentmo, not the cookie. The consent cookie outlives the region it
    // was set in: a visitor who once refused and now browses from somewhere the
    // banner doesn't apply (the Philippines, say) still carries "marketing" in
    // it, yet Consentmo blocks nothing there and has no preferences box to
    // offer. Reading the cookie showed that visitor a notice for a block that
    // wasn't happening, with a button that could never open. marketingAllowed()
    // weighs the saved choice against the visitor's region the same way the
    // blocker does.
    function marketingBlocked() {
      var sdk = window.Consentmo;
      if (sdk && typeof sdk.marketingAllowed === 'function') {
        try {
          return !sdk.marketingAllowed();
        } catch (e) {}
      }
      // Consentmo hasn't loaded yet. Fall back to the saved choice, so an early
      // click never slips a YouTube embed past someone who refused.
      var match = document.cookie.match(/(?:^|;\s*)cookieconsent_preferences_disabled=([^;]*)/);
      if (!match) return false;
      return decodeURIComponent(match[1]).split(',').indexOf('marketing') !== -1;
    }

    function canOpenPreferences() {
      var sdk = window.Consentmo;
      return (
        !!(sdk && typeof sdk.openDialog === 'function') ||
        typeof window.openCookieWidgetPopup === 'function'
      );
    }

    function watchUrl(facade) {
      var id = encodeURIComponent(facade.getAttribute('data-youtube-id') || '');
      return facade.hasAttribute('data-youtube-playlist')
        ? 'https://www.youtube.com/playlist?list=' + id
        : 'https://www.youtube.com/watch?v=' + id;
    }

    // The box renders into the app's shadow root and loads on demand, so it can
    // take a second to appear.
    function preferencesOpened() {
      var root = document.querySelector('.csm-cmp-root');
      var scope = root && root.shadowRoot;
      var dialog = scope && scope.querySelector('[role="dialog"]');
      return !!(dialog && dialog.getClientRects().length);
    }

    function openPreferences(button) {
      var notice = button.closest('.page-video-block__notice');
      var opened = false;
      function onOpened() {
        opened = true;
      }
      document.addEventListener('consentmo:dialogOpened', onOpened);

      var sdk = window.Consentmo;
      if (sdk && typeof sdk.openDialog === 'function') sdk.openDialog('preferences');
      else window.openCookieWidgetPopup();

      // Consentmo refuses to open the box for visitors outside the regions it
      // targets. If it never shows, don't leave a dead button — point to the
      // video on YouTube itself. That plays on youtube.com under YouTube's own
      // terms, so nothing here routes around the block on this page.
      var started = Date.now();
      var timer = setInterval(function () {
        if (!opened && !preferencesOpened() && Date.now() - started < 3000) return;
        clearInterval(timer);
        document.removeEventListener('consentmo:dialogOpened', onOpened);
        if (opened || preferencesOpened()) return;

        if (!notice || notice.querySelector('.page-video-block__fallback')) return;
        var block = notice.parentNode;
        var facade = block && block.querySelector('.page-video-block__facade');
        if (!facade) return;

        var fallback = document.createElement('p');
        fallback.className = 'page-video-block__fallback';
        fallback.appendChild(document.createTextNode("Cookie settings couldn't open here. "));
        var link = document.createElement('a');
        link.href = watchUrl(facade);
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Watch this video on YouTube';
        fallback.appendChild(link);
        fallback.appendChild(document.createTextNode(' instead.'));
        notice.appendChild(fallback);
      }, 250);
    }

    function showNotice(facade) {
      var block = facade.parentNode;
      if (!block || block.querySelector('.page-video-block__notice')) return;

      var notice = document.createElement('div');
      notice.className = 'page-video-block__notice';
      notice.setAttribute('role', 'status');

      var text = document.createElement('p');
      text.textContent =
        'This video is hosted on YouTube, which stays blocked until you accept marketing cookies.';
      notice.appendChild(text);

      if (canOpenPreferences()) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'page-video-block__consent';
        button.textContent = 'Manage cookie preferences';
        notice.appendChild(button);
      }

      block.appendChild(notice);
      var focusable = notice.querySelector('button');
      if (focusable) focusable.focus();
    }

    function play(facade) {
      var id = facade.getAttribute('data-youtube-id');
      if (!id) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'page-video-block__iframe';
      // Playlists embed through the videoseries endpoint; single videos by id.
      iframe.src = facade.hasAttribute('data-youtube-playlist')
        ? 'https://www.youtube.com/embed/videoseries?list=' + encodeURIComponent(id) + '&autoplay=1'
        : 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = facade.getAttribute('aria-label') || 'YouTube video';

      var stale = facade.parentNode.querySelector('.page-video-block__notice');
      if (stale) stale.remove();

      facade.parentNode.replaceChild(iframe, facade);
      iframe.focus();
    }

    // One delegated listener covers every instance of this block on the page.
    document.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;

      var consent = node.closest('.page-video-block__consent');
      if (consent) {
        if (canOpenPreferences()) openPreferences(consent);
        return;
      }

      var facade = node.closest('.page-video-block__facade');
      if (!facade) return;

      if (marketingBlocked()) showNotice(facade);
      else play(facade);
    });

    // Once the visitor accepts marketing in the box, play the video they asked
    // for, rather than making them find it and click it again.
    document.addEventListener('consentmoSignal', function () {
      if (marketingBlocked()) return;
      var notices = document.querySelectorAll('.page-video-block__notice');
      for (var i = 0; i < notices.length; i++) {
        var facade = notices[i].parentNode.querySelector('.page-video-block__facade');
        if (facade) play(facade);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["whl-video"] && !Shopify.designMode) return;
  try {
    class WhlVideo extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.whl-video__poster');
      const embed = this.dataset.embed;
      if (!button || !embed) return;
      button.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = button.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        button.replaceWith(iframe);
        iframe.focus();
      }, { once: true });
    }
  }
  if (!customElements.get('whl-video')) customElements.define('whl-video', WhlVideo);
  } catch(e) { console.error(e); }
})();

})();
